import { ClientOnly } from "@tanstack/react-router";
import AppMenu from "_c/AppMenu/loadable";
import AppHeader from "../AppHeader";
import TopScrollFab from "_c/TopScrollFab";
import cls from "./styles.module.css";
import { Suspense } from "react";
import { usePreloadModules } from "@/hooks/use-preload-modules";
import { useRevealTimezoneToServer } from "@/hooks/use-timezone";
import { useWpAuth } from "@/hooks/use-wp-auth";
import AdminBar from "_c/AdminBar";

const preloadedModules = [AppMenu];
const AppShell: React.FC<{ children: any }> = (props) => {
  usePreloadModules(preloadedModules, { delay: 500 });
  useRevealTimezoneToServer();
  const wpAuth = useWpAuth();

  return (
    <>
      {wpAuth && <AdminBar userName={wpAuth.name} />}
      <AppHeader />
      <ClientOnly>
        <Suspense fallback={null}>
          <AppMenu />
        </Suspense>
        <TopScrollFab />
      </ClientOnly>
      <div className={cls.children}>{props.children}</div>
    </>
  );
};
export default AppShell;
